export default __webpack_public_path__ + "static/media/jcb-image.657e909e.svg";